import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { AuthService } from '../../auth/auth.service';
import { Router } from '@angular/router';
import { LoginComponent } from 'src/app/modules/components/login/login.component';

@Component({
  selector: 'poll-show-header',
  templateUrl: './poll-show-header.component.html',
  styleUrls: ['./poll-show-header.component.css']
})
export class PollShowHeaderComponent implements OnInit {

  constructor(private dialog: MatDialog, public auth: AuthService, private router: Router) { }

  ngOnInit(): void {
  }
  openLogin() {
    let dialogRef = this.dialog.open(LoginComponent, {
      height: '500px',
      width: '600px',
    })
    this.router.events
    .subscribe(() => {
      dialogRef.close();
    })
  }
}
